// English strings for the deploy stream (PD-655 – PD-664; ADR-030). Arabic: ar-deploy.ts.
export const enDeploy = {
  // ------------------------------------------------------------ deployment profile (PD-663)
  'ops.pid.uae-pilot': 'UAE pilot (passage.scinops.com)',
} as const;
